module.exports = __webpack_public_path__ + "static/media/user.88ff5098.svg";